import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Form, FormGroup, Label, Input, Alert, Card, CardBody, Row, Col } from 'reactstrap';
import { BASE_URL } from '../../../constants';

function EditPackage() {
    const [errMsg, setErrMsg] = useState(null);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [productId, setProductId] = useState('');
    const [amount, setAmount] = useState('');
    const [allowedProperties, setAllowedProperties] = useState('');
    const [allowedUsers, setAllowedUsers] = useState('');
    const [hasTrial, setHasTrial] = useState(1);
    const [trialDays, setTrialDays] = useState('');
    const [active, setActive] = useState('');
    const [packageData, setPackageData] = useState(null); 
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();

    useEffect(() => {
        if (location.state && location.state.packages) {
            const { packages } = location.state;
            const packageData = packages.find(item => item.id === parseInt(id));
            if (packageData) {
                setPackageData(packageData); 
                setTitle(packageData.title);
                setDescription(packageData.description);
                setProductId(packageData.ios_product_id);
                setAmount(packageData.amount);
                setAllowedProperties(packageData.allowed_properties);
                setAllowedUsers(packageData.allowed_users);
                setHasTrial(packageData.has_trial);
                setTrialDays(packageData.trial_days);
                setActive(packageData.is_active);
            } else {
                setErrMsg('Error: Package data not found.');
            }
        } else {
            setErrMsg('Error: Package data not available.');
        }
    }, [id, location.state]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Authorization token is missing.');
            }

            const response = await axios.put(`${BASE_URL}/package/update/${id}`, {
                title,
                description,
                amount,
                allowed_properties: allowedProperties,
                allowed_users: allowedUsers,
                ios_product_id: productId,
                has_trial: hasTrial,
                trial_days: trialDays,
                is_active: active
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.status) {
                navigate('/package');
            } else {
                setErrMsg(response.data.message);
            }
        } catch (error) {
            console.error('Error editing package:', error);
            setErrMsg('Error editing package. Please try again.');
        }
    };

    return (
        <div className="content">
            {errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

            <h3>Edit Package</h3>
            <Card>
                <CardBody>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col xs="6">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label for="title">Title*</Label>
                                    <Input type="text" name="title" id="title" value={title} onChange={(e) => setTitle(e.target.value)} />
                                </FormGroup>
                            </Col>

                            <Col xs="6">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label for="amount">Amount*</Label>
                                    <Input 
                                        type="number" 
                                        name="amount" 
                                        id="amount" 
                                        value={amount} 
                                        onChange={(e) => setAmount(e.target.value)} 
                                        disabled={packageData?.is_trial_package === 1} 
                                        />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="6">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label for="allowedProperties">Allowed Properties*</Label>
                                    <Input type="number" name="allowedProperties" id="allowedProperties" value={allowedProperties} onChange={(e) => setAllowedProperties(e.target.value)} />
                                </FormGroup>
                            </Col>

                            <Col xs="6">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label for="allowedUsers">Allowed Users*</Label>
                                    <Input type="number" name="allowedUsers" id="allowedUsers" value={allowedUsers} onChange={(e) => setAllowedUsers(e.target.value)} />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="12">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label for="description">Description*</Label>
                                    <Input type="textarea" name="description" id="description" value={description} onChange={(e) => setDescription(e.target.value)} />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="6">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label for="productId">IOS Product ID</Label>
                                    <Input type="text" name="productId" id="productId" value={productId} onChange={(e) => setProductId(e.target.value)} />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="12">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label check>
                                        <Input 
                                            type="checkbox" 
                                            checked={!!hasTrial} 
                                            style={{ transform: 'scale(1.2)', marginRight: '10px' }} 
                                            onChange={(e) => setHasTrial(e.target.checked ? 1 : 0)} 
                                            disabled={packageData?.is_trial_package === 1} 
                                        />{' '}
                                        Trial
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>

                        {hasTrial == 1 && (
                            <Row>
                                <Col xs="6">
                                    <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                        <Label for="trialDays">Trial Days</Label>
                                        <Input type="number" name="trialDays" id="trialDays" value={trialDays} onChange={(e) => setTrialDays(e.target.value)} />
                                    </FormGroup>
                                </Col>
                            </Row>
                        )}

                        <Row>
                            <Col xs="12">
                                <FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    <Label check>
                                        <Input 
                                            type="checkbox" 
                                            checked={!!active} 
                                            style={{ transform: 'scale(1.2)', marginRight: '10px' }} 
                                            onChange={(e) => setActive(e.target.checked ? 1 : 0)} 
                                            disabled={packageData?.is_trial_package === 1} 
                                        />{' '}
                                        Active
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Button color="primary" type="submit">Submit</Button>
                    </Form>
                </CardBody>
            </Card>
        </div>
    );
}

export default EditPackage;
